const truthyValues = ["1", "true", "yes", "on", "enabled"];

const isEnabledValue = (value) => {
    if (typeof value === "boolean") return value;
    if (typeof value === "number") return value === 1;
    if (typeof value === "string") {
        return truthyValues.includes(value.trim().toLowerCase());
    }
    return false;
};

export const hasMissionTemplatesFeature = (companyData) => {
    const explicitValues = [
        companyData?.features?.missionTemplates,
    ].filter((value) => value !== undefined && value !== null);

    return explicitValues.some(isEnabledValue);
};
